export const getJsonOutputFormatting = (propertyName = 'output', exampleJsonString = '{}', additionalContent) =>
  `The reply must contain exactly one property called ${propertyName}. Format the reply as valid JSON according to this example and before returning the response, verify that it is valid JSON using a JSON parser (e.g., JSONLint, JSON.parse in JavaScript).${additionalContent ? ' ' + additionalContent : ''}
\`\`\`json
${exampleJsonString}
\`\`\``

export const getJsonArrayOutputFormatting = (exampleJsonString = '{}', additionalContent) =>
  `Format the reply as valid JSON according to this example and before returning the response, verify that it is valid JSON using a JSON parser (e.g., JSONLint, JSON.parse in JavaScript).${additionalContent ? ' ' + additionalContent : ''}
\`\`\`json
${exampleJsonString}
\`\`\``
